import axiosInstance from 'config/axiosInstance';
import { MAX_PAGE_SIZE } from 'config/constant';

/** 候補を読むページ数の上限（1ページ MAX_PAGE_SIZE 件、新しい車両から 500 台分）。 */
const MAX_CANDIDATE_PAGES = 5;

/**
 * A07（2026-11-03 和田様の UAT）。車種の入力の候補。同じ会社で過去に入れた車種を、新しく登録した
 * 車両の順に重なりなく返す。
 *
 * 車両の一覧の API（会社の車両だけを返す）を新しい順に読み、車種を集める。候補の専用の API は
 * 足していない。読めなかったときは空（候補なしで、今までどおり自由に入れられる）。
 */
export async function fetchCarModelCandidates(): Promise<string[]> {
  const models: string[] = [];
  const seen = new Set<string>();
  try {
    for (let page = 1; page <= MAX_CANDIDATE_PAGES; page += 1) {
      const response: { data?: { results?: { car_model?: string | null }[]; next?: string | null } } =
        await axiosInstance.get(`/v1/vehicles/?page=${page}&page_size=${MAX_PAGE_SIZE}`);
      (response.data?.results ?? []).forEach((vehicle) => {
        const model = (vehicle.car_model ?? '').trim();
        if (model && !seen.has(model)) {
          seen.add(model);
          models.push(model);
        }
      });
      if (!response.data?.next) break;
    }
  } catch (error) {
    console.error('Failed to fetch car model candidates', error);
  }
  return models;
}
